@if (selfElement$ | async; as selfElement) {
	<stages-tailoring-conditions
		[translateNone]="translateNone"
		[tailoringConditions]="$any(selfElement).tailoringConditions"
	/>
	@if (selfElement.dependentElements | hasDependentTailoringConditions) {
		<hr />
		<stages-common-collapsible-groups
			[preferencesPrefix]="'tailoringConditions'"
			[groups]="selfElement.dependentElements | dependentAsGroup"
			[groupContentTemplate]="tailoringConditions"
			[groupHeaderTemplate]="header"
			[singleGroupCollapsible]="true"
		/>
	}
	<ng-template #tailoringConditions let-group>
		<stages-tailoring-conditions
			[translateNone]="translateNone"
			[tailoringConditions]="$any(group.element).tailoringConditions"
		/>
	</ng-template>
	<ng-template #header let-group>
		<div class="header">
			<span class="h3">
				<span class="h5 group-title">{{ group.type.name }}</span>
				{{ group.name }}
			</span>
			<span class="counter">{{ group.getMemberCount() }}</span>
		</div>
	</ng-template>
}
